// File: ModeSwitch.tsx

import { FC } from "react";
import { Switch } from "@/components/ui/switch";
import { ModeSwitchProps } from "@/types/BigDataMap.types";
import { RefreshCcw } from "lucide-react"; // Importing the refresh icon
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { toast } from "sonner";
const ModeSwitch: FC<ModeSwitchProps> = ({
  selectionMode,
  setSelectionMode,
  setSelectedFeatureId,
  setSelectedAreaCounts,
  setSelectedCluster,
  setSelectedClusterStats,
  resetView, // Destructure resetView from props
}) => {
  return (
    <div className="w-full flex justify-between ">
      <div className="flex items-center gap-2">
        <span className="text-sm">Region</span>
        <Switch
          checked={selectionMode === "cluster"}
          onCheckedChange={(checked) => {
            console.log("Switching mode to:", checked ? "cluster" : "region");
            setSelectionMode(checked ? "cluster" : "region");
            setSelectedFeatureId(null);
            setSelectedAreaCounts(null);
            setSelectedCluster(null);
            setSelectedClusterStats(null);
            toast(`${selectionMode.charAt(0).toUpperCase() + selectionMode.slice(1)} Selected`)
          }}
        />
        <span className="text-sm">Cluster</span>
      </div>
      <div className="flex items-center space-x-2">

        {/* Reset Button */}
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
              onClick={()=>{
                resetView();
                toast('Map Reset to Initial View')
              }} variant="ghost" size="icon" className=" rounded-full">
                <RefreshCcw size={16} className="" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Reset Map</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};

export default ModeSwitch;
